// ------------------------------------------------------------------------------
// CustomLogin
// author: mudas
// created: 2025/3/31
// ------------------------------------------------------------------------------

import React, { FC } from 'react';
import { useAppSelector } from '@tiangong/hooks';
import { openURL } from 'common/utils';

import { LoginPayload, useAntStaticComponent, useLoginNext, getNextPath, isOutPlatform } from 'common/hooks';
import { ROUTER_PATHNAME } from 'common/router/routes';
import { selectTheme } from '@tiangong/store/theme';

import { CommonLogin } from 'common/components';

export interface IProps {
  // 登录页根路径类型（主要用于区分在对外环境包含对内、对外两种风格登录界面）
  rootPath?: ROUTER_PATHNAME;
}

const CustomLogin: FC<IProps> = ({ rootPath }) => {
  const { message } = useAntStaticComponent();

  const { theme } = useAppSelector(selectTheme);
  const { agreement, toNext } = useLoginNext();

  // --------------------------------------------------------------------------
  //
  // Class methods
  //
  // --------------------------------------------------------------------------

  // 支持外部同域平台登录和跳转回原地址
  const loginAgent = async (value: LoginPayload) => {
    const target = getNextPath();

    message.success('登录成功!');
    await agreement();

    if (isOutPlatform()) {
      openURL(target, '_self');
    } else {
      await toNext();
    }
  };

  // --------------------------------------------------------------------------
  //
  // Event handlers
  //
  // --------------------------------------------------------------------------

  const handleSuccess = async (value: LoginPayload) => {
    await loginAgent(value);
  };

  return <CommonLogin rootPath={rootPath} closable={!isOutPlatform()} theme={theme} onSuccess={handleSuccess} />;
};

export default CustomLogin;
